export class LayoutColumn {
  public fieldName: string;
  public hidden: boolean;
  public ordering: number | undefined;
  public size: number;

  constructor(fieldName: string, ordering = 0, hidden = false, size = 0) {
    this.fieldName = fieldName;
    this.ordering = ordering;
    this.hidden = hidden;
    this.size = size;
  }
}
